import {Component, effect, ElementRef, inject, signal, viewChild} from "@angular/core";
import {
  InternalNotification,
  InternalNotificationsStore,
  InternalNotificationType
} from "src/app/infrastructure/internal-notifications/internal-notifications.store";
import {HapticsService} from "src/app/infrastructure/haptics.service";
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";

@Component({
  selector: 'app-internal-notifications',
  templateUrl: './internal-notifications.component.html',
  imports: [
    GenericButtonComponent
  ],
  styleUrl: './internal-notifications.component.css'
})
export class InternalNotificationsComponent {

  visible = signal(false);
  internalNotificationsStore = inject(InternalNotificationsStore);
  protected showTechDetails: boolean = false
  private readonly el = viewChild<ElementRef<HTMLDivElement>>('notification');

  constructor(
    private readonly hapticsService: HapticsService
  ) {
    effect(() => {
      const notification = this.internalNotificationsStore.notification();
      if (!notification) return;

      switch (notification.type) {
        case InternalNotificationType.ERROR: {
          this.hapticsService.error();
          break;
        }
        case InternalNotificationType.WARNING: {
          this.hapticsService.warning();
          break;
        }
      }

      window.setTimeout(() => this.visible.set(true));
      if (!notification.persist) {
        window.setTimeout(() => this.dismissNotification(notification), 3000);
      }
    });

    effect(() => {
      const el = this.el();
      if (!el) this.visible.set(false);
    });
  }

  icon() {
    const notification = this.internalNotificationsStore.notification();
    if (!notification) return '';

    const type = notification.type;
    switch(type) {
      case InternalNotificationType.ERROR: return 'fa-circle-xmark error-icon';
      case InternalNotificationType.INFO: return 'fa-circle-info info-icon';
      case InternalNotificationType.SUCCESS: return 'fa-check success-icon';
      case InternalNotificationType.WARNING: return 'fa-triangle-exclamation warning-icon';
    }
  }

  dismissNotification(notification: InternalNotification) {
    if (notification !== this.internalNotificationsStore.notification()) return;

    this.visible.set(false);
    const el = this.el();
    if (el) {
      el.nativeElement.addEventListener('transitionend', () => {
        this.internalNotificationsStore.deleteNotification(notification);
      });
    } else {
      this.internalNotificationsStore.deleteNotification(notification);
    }
  }
}
